const Int = 'int';
const Qa = 'qa';
const Perf = 'perf';
const Prod = 'prod';
const Sandbox = 'sandbox';

export function getEnvironmentLabel() {
  const { hostname } = window.location;

  if (/localhost/i.test(hostname)) {
    return null;
  }

  const hostnameRegex = /react-(\w+)\.sorted\.com/i;
  const match = hostname.match(hostnameRegex);

  if (match) {
    const label = match[1];
    return label.toLowerCase();
  }
  // fallback to prod label because we expect custom domain to be used on prod.
  return Prod;
}

export const environmentLabels = {
  Int,
  Qa,
  Perf,
  Prod,
  Sandbox,
};
